export default __webpack_public_path__ + "static/media/sadd.85796766.svg";